/**
 * Project Detail - Assigns reveal animation types to flexible content blocks
 * Reveal observation handled by scrollReveal.js (js-reveal class)
 */
import { observeRevealElements } from "./scrollReveal.js";

document.addEventListener("DOMContentLoaded", function () {
  var page = document.querySelector(".is-project-detail");
  if (!page) return;

  var animationMap = {
    "pj-block--content_image": "fade-right",
    "pj-block--title_content": "fade-up",
    "pj-block--image_image": "fade-up",
    "pj-block--single_image": "zoom-in",
    "pj-block--title_image": "fade-up",
    "pj-block--image_image_image": "fade-up",
  };

  // Tag blocks with animation type + js-reveal
  var blocks = document.querySelectorAll(".pj-block");
  blocks.forEach(function (block) {
    block.classList.add("js-reveal", "pj-reveal");

    var animType = "fade-up";
    for (var cls in animationMap) {
      if (block.classList.contains(cls)) {
        animType = animationMap[cls];
        break;
      }
    }
    block.setAttribute("data-reveal", animType);

    var children = block.querySelectorAll(".pj-block__img, .pj-block__text, .pj-block__title, .pj-block__desc");
    children.forEach(function (child, i) {
      child.classList.add("pj-reveal__child");
      child.style.transitionDelay = i * 0.15 + "s";
    });
  });

  // Tag hero and footer
  var extras = [
    { sel: ".pj-detail-hero__image", anim: "zoom-in" },
    { sel: ".pj-detail-footer__tags", anim: "fade-up" },
    { sel: ".pj-detail-footer__nav", anim: "fade-up" },
  ];

  extras.forEach(function (item) {
    var el = document.querySelector(item.sel);
    if (el) {
      el.classList.add("js-reveal", "pj-reveal");
      el.setAttribute("data-reveal", item.anim);
    }
  });

  // Re-observe newly tagged elements
  observeRevealElements();
});
